import ReactFlowComponent from './ReactFlowComponent';
import './App.css';

function App({ bubbleInstance, initialDataJSON }) {
  return (
    <div className="App" style={{ width: '100%', height: '100%' }}>
      <ReactFlowComponent bubbleInstance={bubbleInstance} initialDataJSON={initialDataJSON} />
    </div>
  );
}

export default App;
